<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto;">
      <div class="row">
        <div class="col-4">
          <h1>Report Management</h1>
        </div>
        <div class="col-4">
          <br />
          <ng-container *ngIf="loadingData">
            <i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;Loading Report Data, Please Wait...
          </ng-container>
          <ng-container *ngIf="refreshingData">
            <i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;Refreshing Report Data, Please Wait...
          </ng-container>
        </div>
        <div class="col-4">
          <mat-form-field style="width: 100%">
            <mat-label>Report Section:</mat-label>
            <mat-select name="reportSection" [(ngModel)]="reportSectionId">
              <mat-option *ngIf="this.userState?.reportExportState?.reportStandardTypes?.length > 0" [value]="0">Report Layouts</mat-option>
              <mat-option *ngIf="this.userState?.reportExportState?.reportStandardTypes?.length > 0" [value]="1">Report Exports</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!loadingData && reportSectionId === 0" style="margin-top: 10px">
    <mat-card-content>
      <mat-card style="margin-top: 10px">
        <mat-card-content style="margin-left: auto; margin-right: auto;">
          <div class="row">
            <div class="col-md-2"><b>Select Report: </b></div>
            <div class="col-md-7">
              <mat-select name="selectedStandardReport" [(ngModel)]="selectedStandardReport" (selectionChange)="reportStandardTypeChanged()">
                <mat-option *ngFor="let report of reportStandardTypes" [value]="report">{{ report.name }}</mat-option>
              </mat-select>
            </div>
            <div class="col-md-3">
              <button *ngIf="selectedStandardReport != null" mat-raised-button class="piButton" (click)="createNewLayout()">Create New Layout</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card style="margin-top: 10px">
        <mat-card-content style="margin-left: auto; margin-right: auto;">
          <ng-container *ngIf="selectedStandardReport != null">
            <div class="row">
              <div class="col-md-1 mainLabel"></div>
              <div class="col-md-11 mainLabel">Layout Name</div>
            </div>
            <div class="row table-row" *ngFor="let layout of selectedStandardReport.layouts">
              <div class="col-md-1">
                <a href="#" *ngIf="canEditReport()" (click)="editLayout(layout)"><span class="fas fa-edit" title="Edit Layout"></span></a>&nbsp;&nbsp;
                <a href="#" *ngIf="canEditReport()" (click)="deleteLayout(layout)"><span class="fas fa-trash" title="Delete Layout"></span></a>&nbsp;&nbsp;
                <a href="#" (click)="exportReport(layout)"><span class="fas fa-file-pdf" title="Generate Report"></span></a>
              </div>
              <div class="col-md-11" style="vertical-align: middle">
                {{layout.name}}
              </div>
            </div>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!loadingData && reportSectionId === 1">
    <mat-card-content>
      <div class="row">
        <div class="col-md-1 mainLabel"></div>
        <div class="col-md-2 mainLabel">Report</div>
        <div class="col-md-2 mainLabel">Requested</div>
        <div class="col-md-1 mainLabel">Status</div>
        <div class="col-md-2 mainLabel">Last Updated</div>
        <div class="col-md-2 mainLabel">Last Message</div>
        <div class="col-md-2 mainLabel">Expiration</div>
      </div>
      <ng-container *ngFor="let export of userState?.reportExportState?.reportExports | sortByLastUpdated; let i = index">
        <div class="row table-row">
          <div class="col-md-1">
            <a href="#" (click)="deleteExport(export)"><span class="fas fa-trash" title="Delete Report"></span></a>&nbsp;&nbsp;
            <ng-container *ngIf="export.status == 3">
              <a [href]="export.downloadUrl" download="report.pdf"><span class="fas fa-download" title="Download Report"></span></a>
            </ng-container>
          </div>
          <div class="col-md-2"><b>{{ export.layoutName }}</b></div>
          <div class="col-md-2">{{ export.requested | date: 'MM/dd/yy hh:mm aa' }} UTC</div>
          <div class="col-md-1">
            <ng-container *ngIf="export.status == 0">Requested</ng-container>
            <ng-container *ngIf="export.status == 1">Processing</ng-container>
            <ng-container *ngIf="export.status == 2">Saving</ng-container>
            <ng-container *ngIf="export.status == 3">Ready</ng-container>
          </div>
          <div class="col-md-2">{{ export.lastUpdate | date: 'MM/dd/yy hh:mm aa' }} UTC</div>
          <div class="col-md-2">{{ export.statusMessage }}</div>
          <div class="col-md-2">{{ export.expirationDate | date: 'MM/dd/yy hh:mm aa' }} UTC</div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
<div [hidden]="!showPowerBi" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1000; background-color: #106bae">
  <app-powerbi-report-embed (closeClicked)="closeClicked()" (saveClicked)="saveClicked()"></app-powerbi-report-embed>
</div>
